// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.I7eorNX8WawvqtS6{max-width:228px;white-space:pre;overflow:hidden;text-overflow:ellipsis}.Qw9LwliHi4MrCgTe{height:100%;display:flex;align-items:center}.Qw9LwliHi4MrCgTe .XU9uVFC5vRgttGnQ{width:100%;display:flex;align-items:center;justify-content:space-between}.Qw9LwliHi4MrCgTe .XU9uVFC5vRgttGnQ .HeSozAvdI4K7dxB0{width:50%;height:48px;display:flex;align-items:center;justify-content:center}.Qw9LwliHi4MrCgTe .XU9uVFC5vRgttGnQ .cOAzYHb7V4SXdZjK{margin-right:auto;margin-left:16px;white-space:nowrap}.Qw9LwliHi4MrCgTe .XU9uVFC5vRgttGnQ .kqfMHxx8r8SwEEX6{overflow:hidden;height:48px;flex-grow:1;max-width:106px;margin-left:16px}.Qw9LwliHi4MrCgTe .XU9uVFC5vRgttGnQ h1{line-height:48px;font-size:48px;letter-spacing:-2.4px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cohortName": `I7eorNX8WawvqtS6`,
	"cardBody": `Qw9LwliHi4MrCgTe`,
	"summary": `XU9uVFC5vRgttGnQ`,
	"spinRow": `HeSozAvdI4K7dxB0`,
	"percentChange": `cOAzYHb7V4SXdZjK`,
	"barchart": `kqfMHxx8r8SwEEX6`
};
export default ___CSS_LOADER_EXPORT___;
